module.exports = __webpack_public_path__ + "img/img1.b2ce737.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img1.png
// module id = 219
// module chunks = 0